// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","FacetImage":"_3te1ZK","facetText":"Q3XFli","primeFacet":"JV4BwB","fadeInFrames":"_2a4j1B"};